'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Link = function Link(_ref) {
  var to = _ref.to,
      onClick = _ref.onClick,
      children = _ref.children;

  var fullPath = to.pathname;
  if (to.query) {
    fullPath += '?' + Object.keys(to.query).map(function (k) {
      return encodeURIComponent(k) + '=' + encodeURIComponent(to.query[k]);
    }).join('&');
  }
  return _react2.default.createElement(
    'a',
    { href: fullPath, onClick: onClick },
    children
  );
};

Link.propTypes = {
  /** The contents of the link. */
  children: _propTypes2.default.node.isRequired,
  /** Object specifying where the link should point to; based on react-router Link component */
  to: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired,
    query: _propTypes2.default.object
  }).isRequired,
  /** onClick action to be passed on to the link */
  onClick: _propTypes2.default.func
};

Link.defaultProps = {
  onClick: function onClick() {}
};

exports.default = Link;
Link.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'Link',
  'props': {
    'onClick': {
      'defaultValue': {
        'value': '() => {}',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'onClick action to be passed on to the link'
    },
    'children': {
      'type': {
        'name': 'node'
      },
      'required': true,
      'description': 'The contents of the link.'
    },
    'to': {
      'type': {
        'name': 'shape',
        'value': {
          'pathname': {
            'name': 'string',
            'required': true
          },
          'query': {
            'name': 'object',
            'required': false
          }
        }
      },
      'required': true,
      'description': 'Object specifying where the link should point to; based on react-router Link component'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/Link.js
// module id = 271
// module chunks = 0